<template>
  <div class="field" :class="classes">
    <div class="level label">
      <div class="level-left">
        <svgicon
          class="level-item label-icon"
          :name="icon"
          :color="dynamicColor"
          width="20"
          height="20">
        </svgicon>
        <p class="level-item" :class="{ disabled: !enabled }">{{ title }}</p>
      </div>
    </div>
    <div class="control">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormField',
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: null,
    },
    iconColor: {
      type: String,
      default: '#C4FFF9',
    },
    classes: {
      type: String,
      default: '',
    },
    enabled: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    dynamicColor() {
      if (this.enabled) {
        return this.iconColor;
      }
      return 'grey';
    },
  },
};
</script>

<style lang="scss" scoped>
.level-left {
  svg.label-icon {
    margin-right: .5rem;
  }
}

.disabled {
  color: grey;
}
</style>
